<template>
    <div>
        <h1 class="text-center">Edit Motion</h1>
        <section class="Message">
            <div class="row">

                <form class="ui form addMotionForm"  @submit.prevent="$_admin_motion_edit_checkEditMessage">
                    <div class="col-md-12">

                        <div class="box box-info">
                            <div class="box-body">
                                <button
                                    type="button"
                                    class="btn bg-olive margin"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    :title="$t('add')"
                                    @click="$_admin_motion_edit_addRow">
                                    {{$i18n.messages[$i18n.locale].descAddI18n}}
                                </button>
                                <div
                                    v-for="(o, index) in motionFile.i18n"
                                    class="row">
                                    <div class="col-md-8">
                                        <label>{{$i18n.messages[$i18n.locale].desc}}:</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                              <i
                                                  class="fa fa-fw fa-edit"
                                                  aria-hidden="true">
                                              </i>
                                            </span>
                                            <input
                                                v-model="o.description"
                                                class="form-control"
                                                placeholder="description"
                                                type="text">
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-3"
                                        v-bind:class="{ 'form-group has-error': $v.motionFile.i18n.$each[index].$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].langCode}}:</label>
                                        <label v-if="!$v.motionFile.i18n.$each[index].langCode.required">{{$i18n.messages[$i18n.locale].required}}</label>

                                        <div class="input-group">
                                            <span class="input-group-addon">
                                              <i
                                                  class="fa fa-fw fa-edit"
                                                  aria-hidden="true">
                                              </i>
                                            </span>
                                            <select
                                                id="langCode"
                                                v-model="o.langCode"
                                                class="form-control"
                                            >
                                                <option value="zh-CN">{{$i18n.messages[$i18n.locale].typeZHCN}}</option>
                                                <option value="zh-TW">{{$i18n.messages[$i18n.locale].typeZHTW}}</option>
                                                <option value="en">{{$i18n.messages[$i18n.locale].typeEN}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-1 trash">
                                        <a
                                            class="btn btn-danger"
                                            href="#"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            :title="$t('trash')"
                                            @click="$_admin_motion_edit_removeRow(o)">
                                            <i class="fa fa-trash-o fa-lg"></i></a>
                                    </div>
                                </div>

                                <br />
                            </div>
                        </div>
                        
                        <div class="box box-info">
                            <!-- Input Addons -->
                            <div class="box-header with-border">
                                <h3 class="box-title">Inputs</h3>
                            </div>

                            <div class="box-body">

                                <div class="row">
                                    <div
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.motionFile.name.$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].motionName}}:</label>
                                        <label v-if="!$v.motionFile.name.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="motionFile.name"
                                                class="form-control"
                                                placeholder="name"
                                                type="text"
                                                ref="addMotionTitle">
                                        </div>
                                    </div>

                                    <div 
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.motionFile.type.$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].type}}:</label>
                                        <label v-if="!$v.motionFile.type.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <select
                                                id="type"
                                                v-model="motionFile.type"
                                                class="form-control"
                                            >
                                                <option value="motion">motion</option>
                                                <option value="motion_bin">motion_bin</option>
                                                <option value="maya">maya</option>
                                                <option value="media">media</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div
                                        class="col-md-6"
                                        v-bind:class="{ 'form-group has-error': $v.motionFile.category.$invalid }"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].category}}:</label>
                                        <label v-if="!$v.motionFile.category.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-book"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <select
                                                v-model="motionFile.category"
                                                class="form-control">
                                                <option
                                                    v-for="(category, index) in categories"
                                                    v-bind:value="category.motionCategoryId"
                                                >
                                                    {{category.i18n.description}}
                                                </option>

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div
                                        v-if="motionFile.type"
                                        class="col-md-6"
                                        v-bind:class="{ 'form-group has-error': $v.motionFile.fileName.$invalid }"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].downloadUrl}}:</label>
                                        <label v-if="!$v.motionFile.fileName.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-download"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input @change="$_admin_motion_upload($event, 'fileName')" type="file" v-bind:accept="fileAccept">
                                            <input
                                                v-model="motionFile.fileName"
                                                class="form-control"
                                                placeholder="file name"
                                                type="text">
                                        </div>
                                    </div>

                                </div>
                                
                                <div class="row">
                                    <div
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.motionFile.time.$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].time}}:</label>
                                        <label v-if="!$v.motionFile.time.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="motionFile.time"
                                                class="form-control"
                                                placeholder="time"
                                                type="text"
                                                ref="addMotionTitle">
                                        </div>
                                    </div>

                                    <div 
                                    class="col-md-6"
                                    v-bind:class="{ 'form-group has-error': $v.motionFile.size.$invalid }">
                                        <label>{{$i18n.messages[$i18n.locale].size}}:</label>
                                        <label v-if="!$v.motionFile.size.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-balance-scale"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <input
                                                v-model="motionFile.size"
                                                class="form-control"
                                                placeholder="size"
                                                type="text">
                                        </div>
                                    </div>
                                </div>

                                <!-- /input-group -->
                            </div>

                            <!-- /.box-body -->
                            <div v-bind:class="{overlay: true, hidden: !loading}">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                        </div>

                        <div class="box box-info">
                            <div class="box-body">
                                

                                <div class="row">
                                    <div class="col-md-3">
                                        <label>{{$i18n.messages[$i18n.locale].keyword}}:</label>
                                        <input
                                            v-model="keyword"
                                            class="form-control"
                                            type="text">
                                    </div>

                                    <div class="col-md-1">
                                        <label>&nbsp;</label><br>
                                        <button 
                                            id="searchSubmitButton"
                                            type="button"
                                            v-bind:class="'btn'"
                                            @click="$_admin_motion_tag_search"
                                            >
                                            <i class="glyphicon glyphicon-search"></i>
                                        </button>
                                    </div>

                                    <div
                                        class="col-md-3"
                                        v-bind:class="{ 'form-group has-error': $v.motionFile.tagIds.$invalid }"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].tag}}:</label>
                                        <label v-if="!$v.motionFile.tagIds.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-tags"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <select
                                                v-model="tempTagList"
                                                multiple=""
                                                size="4"
                                                class="form-control">
                                                <option
                                                    v-for="(tag, index) in tags"
                                                    v-bind:value="tag">
                                                    {{tag.i18n.description}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-1">
                                        <label>&nbsp;</label><br>
                                        <button 
                                            id="searchSubmitButton"
                                            type="button"
                                            v-bind:class="'btn'"
                                            @click="$_admin_motion_tag_add"
                                            >
                                            <i class="glyphicon glyphicon-menu-right"></i>
                                        </button>
                                    </div>

                                    <div
                                        class="col-md-3"
                                        v-bind:class="{ 'form-group has-error': $v.motionFile.tagIds.$invalid }"
                                    >
                                        <label>{{$i18n.messages[$i18n.locale].tag}}:</label>
                                        <label v-if="!$v.motionFile.tagIds.required">{{$i18n.messages[$i18n.locale].required}}</label>
                                        <div class="input-group">
                                            <span class="input-group-addon">
                                                <i
                                                    class="fa fa-fw fa-tags"
                                                    aria-hidden="true">
                                                </i>
                                            </span>
                                            <select
                                                v-model="motionFile.tagIds"
                                                multiple=""
                                                size="4"
                                                class="form-control">
                                                <option
                                                    v-for="(tag, index) in tags"
                                                    v-bind:value="tag.motionTagId">
                                                    {{tag.i18n.description}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <!-- /input-group -->
                            </div>

                            <!-- /.box-body -->
                            <div v-bind:class="{overlay: true, hidden: !loading}">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                        </div>

                        <div class="box">
                            <br />
                            <div class="row">
                                <div class="col-md-5">
                                </div>
                                <div class="col-md-2">
                                    <button
                                        type="button"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        :title="$t('clear')"
                                        :class="'btn btn-warning btn-lg ' + loading"
                                        @click="$_admin_motion_edit_clearInput()">
                                        {{$i18n.messages[$i18n.locale].clear}}
                                    </button>
                                    <button
                                        type="submit"
                                        :disabled="$v.$invalid || isUploading"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        :title="$t('submit')"
                                        :class="'btn btn-primary btn-lg ' + loading">
                                        {{isUploading ? $i18n.messages[$i18n.locale].uploading : $i18n.messages[$i18n.locale].submit}}
                                    </button>
                                </div>
                                <div class="col-md-5">
                                </div>
                            </div>
                            <br />
                            <div v-bind:class="{overlay: true, hidden: !loading}">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                        </div>

                        <div
                            class="alert alert-success alert-dismissible"
                            v-bind:class="{hidden: !insertSuccess}">
                            <button
                                type="button"
                                class="close"
                                data-dismiss="alert"
                                aria-hidden="true"
                                @click="$_admin_motion_edit_closeAndRedirect()">
                                &times;
                            </button>
                            <h4><i class="icon fa fa-check"></i> {{$i18n.messages[$i18n.locale].success}}!</h4>
                        </div>

                    </div>
                </form>

            </div>
        </section>
    </div>
</template>
<script>
    import api from '../../api'
    import config from '../../config'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'EditMessage',
        components: {
        },
        validations () {
            let data = {
                motionFile: {
                    i18n: {
                        $each: {
                            langCode: {
                                required
                            }
                        }
                    },
                    name: {
                        required
                    },
                    type: {
                        required
                    },
                    category: {
                        required
                    },
                    tagIds: {
                        required
                    },
                    fileName: {
                        required
                    },
                    size: {
                        required
                    },
                    time: {
                        required
                    }
                }
            }
            return data
        },
        data () {
            return {
                section: 'EditMessage',
                emptySpace: '',
                loading: false,
                insertSuccess: false,
                fileAccept: '.fst,.mp4,.xml',
                toggle: [
                    {target: 'fileName', isBusy: false}
                ],
                isUploading: false,
                motionFile: {
                    name: '',
                    type: '',
                    i18n: [{description: '', langCode: ''}],
                    size: 0,
                    time: '',
                    category: '',
                    tagIds: [],
                    fileName: ''
                },
                categories: [],
                tags: [],
                tempTagList: [],
                tagList: [],
                keyword: ''
            }
        },
        mounted () {
            this.$_admin_motion_edit_findMotion(this.$route.params.motionFileId)
            this.$_admin_motion_file_list_getCategoriesOrChannelsOrTagsOrMarket(config.developerApiMotionCategory)
            this.$_admin_motion_file_list_getCategoriesOrChannelsOrTagsOrMarket(config.developerApiMotionTag)
        },
        methods: {
            $_admin_motion_edit_clearInput () {
                this.loading = false
                this.tempTagList = []
                this.tagList = []
                this.motionFile.tagIds = []
            },
            $_admin_motion_edit_checkEditMessage () {
                const {name, fileName, category, time, size, type, i18n} = this.motionFile

                this.$_admin_motion_edit_toggleLoading()
                const headers = {'authorization': this.$store.state.token}
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiMotionFile + this.motionFile.motionId
                /* eslint-disable object-property-newline */
                let body = {name, fileName, category, time, size, type, i18n}
                if (this.motionFile.tagIds) {
                    body.tags = this.motionFile.tagIds
                }

                api.request('put', path, body, {}, headers)
                    .then(response => {
                        const data = response.data
                        /* Checking if error object was returned from the server */
                        if (data.error) {
                            const errorName = data.error.name
                            if (errorName) {
                                this.response = errorName
                            } else {
                                this.response = data.error
                            }
                            return
                        }

                        /* Setting user in the state and caching record to the localStorage */
                        if (response.data.status.code === 0) {
                            this.insertSuccess = true
                            setTimeout(function () { this.$router.push({name: 'listMotionFileForAdmin'}) }.bind(this), 1000)
                        }
                    })
                    .catch(error => {
                        this.$store.commit('TOGGLE_LOADING')
                        console.log(error)

                        this.response = 'Server appears to be offline'
                        this.$_admin_motion_edit_toggleLoading()
                    })
            },
            $_admin_motion_edit_toggleLoading () {
                this.loading = !this.loading
            },
            $_admin_motion_edit_closeAndRedirect () {
                this.$router.push({name: 'listMotionFileForAdmin'})
            },
            $_admin_motion_edit_findMotion (motionFileId) {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiMotionFile + motionFileId
                const headers = {'authorization': this.$store.state.token}
                console.log('get ' + path)
                return api.request('get', path, {}, {}, headers)
                    .then(response => {
                        const data = response.data.data.payload[0]
                        this.motionFile = data
                        this.motionFile.type = data.path.split('/')[1]
                        this.motionFile.tagIds = []
                        if (data.tags) {
                            for (let i = 0; i < data.tags.length; i++) {
                                this.motionFile.tagIds.push(data.tags[i]._id)
                            }
                        }
                        if (data.category) {
                            this.motionFile.category = data.category._id
                        }
                    })
            },
            $_admin_motion_edit_addRow () {
                this.motionFile.i18n.push({ description: '', langCode: '' })
            },
            $_admin_motion_edit_removeRow (row) {
                const index = this.motionFile.i18n.indexOf(row)
                this.motionFile.i18n.splice(index, 1)
            },
            $_admin_motion_tag_search () {
                const path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + config.developerApiMotionTag
                const headers = {'authorization': this.$store.state.token}
                let params = {langCode: 'zh-CN'}
                if (this.keyword) {
                    params.keyword = this.keyword
                }
                return api.request('get', path, {}, params, headers)
                        .then(response => {
                            this.tags = response.data.data.payload
                        })
            },
            $_admin_motion_tag_add () {
                for (let i = 0; i < this.tempTagList.length; i++) {
                    this.tagList.push(this.tempTagList[i])
                    this.motionFile.tagIds.push(this.tempTagList[i].motionTagId)
                }
                this.tempTagList = []
            },
            $_admin_motion_file_list_getCategoriesOrChannelsOrTagsOrMarket (type) {
                const headers = {'authorization': this.$store.state.token}
                let path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix
                let params = {langCode: 'zh-CN'}
                if (type === config.developerApiMotionCategory) {
                    path = path + config.developerApiMotionCategory
                } else if (type === config.developerApiMotionTag) {
                    path = path + config.developerApiMotionTag
                }
                params.limit = 1000
                return api.request('get', path, {}, params, headers)
                    .then(response => {
                        if (type === config.developerApiMotionCategory) {
                            this.categories = response.data.data.payload
                        } else if (type === config.developerApiMotionTag) {
                            this.tags = response.data.data.payload
                            // this.tagList = response.data.data.payload
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            $_admin_motion_upload (event, target) {
                this.$store.commit('TOGGLE_LOADING')
                this.$_admin_motion_edit_toggle_target(target)
                let formData = new FormData()
                formData.append('uploadFile', event.target.files[0])
                const headers = {
                    'authorization': this.$store.state.token,
                    'Content-Type': 'multipart/form-data'
                }
                let path = config.env[location.hostname.split('.')[0]].developerApiDomain + config.developerApiVersion + config.developerApiPrefix + this.motionFile.type + '/' + config.developerApiUpload
                api.request('post', path, formData, {}, headers)
                    .then(response => {
                        const data = response.data
                        console.log(data)
                        if (data.status.code === 0) {
                            this.motionFile[target] = data.data.name
                            if (target === 'fileName') {
                                this.motionFile.size = data.data.size + ''
                            }
                        }
                        this.$store.commit('TOGGLE_LOADING')
                        this.$_admin_motion_edit_toggle_target(target)
                    })
                    .catch(err => {
                        console.log(err)
                        this.$store.commit('TOGGLE_LOADING')
                        this.$_admin_motion_edit_toggle_target(target)
                    })
            },
            $_admin_motion_edit_toggle_target (target) {
                this.toggle.forEach(data => {
                    if (data.target === target) {
                        data.isBusy = !data.isBusy
                    }
                })
                this.isUploading = this.$_admin_motion_edit_check_toggle()
            },
            $_admin_motion_edit_check_toggle () {
                let isBusy = false
                this.toggle.forEach(data => {
                    if (data.isBusy) {
                        isBusy = true
                    }
                })
                return isBusy
            }
        }
    }
</script>

<style scoped>
    .input-group input {
        height: 34px;
    }

    .trash {
        position: relative;
        transform: translateY(70%);
    }
</style>



// WEBPACK FOOTER //
// EditMotionFileForAdmin.vue?19bef5a0